exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#main[data-v-210d5cf0]{width:100%;min-height:500px;margin-top:50px;display:inline-table;font-family:RalewayRegular;margin-bottom:20px\n}\n", "", {"version":3,"sources":["/Applications/MAMP/htdocs/freelas/click2giv_v2/click2giv/src/components/Privacy.vue"],"names":[],"mappings":";AAmEA,uBACE,WACA,iBACA,gBACA,qBACA,2BACA,kBAAmB;CACpB","file":"Privacy.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n#main{\n  width: 100%;\n  min-height: 500px;\n  margin-top: 50px;\n  display: inline-table;\n  font-family: RalewayRegular;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-210d5cf0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Privacy.vue
// module id = II/e
// module chunks = 0